export interface LayoutScrollPin {
  pin(): void;
  release(): void;
}

export function createLayoutScrollPin(scrollEl: HTMLElement): LayoutScrollPin {
  let pinned = true;

  const scrollToBottom = () => {
    if (pinned) scrollEl.scrollTop = scrollEl.scrollHeight;
  };

  const resizeObserver = new ResizeObserver(scrollToBottom);
  const observedChildren = new Set<Element>();
  const observeChildren = () => {
    for (const child of scrollEl.children) {
      if (observedChildren.has(child)) continue;
      observedChildren.add(child);
      resizeObserver.observe(child);
    }
  };

  resizeObserver.observe(scrollEl);
  observeChildren();

  const mutationObserver = new MutationObserver(() => {
    observeChildren();
    scrollToBottom();
  });
  mutationObserver.observe(scrollEl, { childList: true });

  const stopPinning = () => {
    pinned = false;
  };
  const interactionEvents = [
    "keydown",
    "pointerdown",
    "touchstart",
    "wheel",
  ] as const;
  for (const event of interactionEvents) {
    scrollEl.addEventListener(event, stopPinning, { passive: true });
  }

  return {
    pin() {
      pinned = true;
      scrollToBottom();
    },
    release() {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
      for (const event of interactionEvents) {
        scrollEl.removeEventListener(event, stopPinning);
      }
    },
  };
}
